import { z } from 'zod';

export const createDiscountPackageValidator = z.object({
   code: z.string().trim().min(1, 'Code is required'),
   amount: z
      .number({ message: 'Amount is required' })
      .min(1, 'Amount is required')
      .max(100, 'Amount must be less than 100'),
   expiry_date: z.string().refine(
      date => {
         const parsedDate = Date.parse(date);
         const today = new Date();
         today.setHours(0, 0, 0, 0);
         return !isNaN(parsedDate) && new Date(parsedDate) >= today;
      },
      {
         message: 'Expiry date must be in the future',
      },
   ),
   title: z.string().trim().min(1, 'Title is required'),
   description: z.string().trim().min(1, 'Description is required'),
   amount_type: z.string().min(1, 'Amount type is required'),
});

export const updatePackageDiscountValidator = z.object({
   code: z.string().trim().min(1, 'Code is required'),
   amount: z
      .number({ message: 'Amount is required' })
      .min(1, 'Amount is required')
      .max(100, 'Amount must be less than 100'),
   expiry_date: z.string().refine(
      date => {
         const parsedDate = Date.parse(date);
         const today = new Date();
         today.setHours(0, 0, 0, 0);
         return !isNaN(parsedDate) && new Date(parsedDate) >= today;
      },
      {
         message: 'Expiry date must be in the future',
      },
   ),
   title: z.string().trim().min(1, 'Title is required'),
   description: z.string().trim().min(1, 'Description is required'),
   amount_type: z.string().trim().min(1, 'Amount type is required'),
});

export type TPackageDiscount = z.infer<typeof createDiscountPackageValidator>;
